export default __webpack_public_path__ + "66f058e171d1fee3411bef921ed68ccc.jpg";